// @ts-nocheck
import * as React from 'react';
import { FC } from 'react';
import {
    List,
    ListProps,
    Datagrid,
    TextField,
    FunctionField,
    DateField,
    NumberField,
    Filter,
    FilterProps, TextInput, SelectInput, useAuthenticated, useLoading, AutocompleteInput, ReferenceInput,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import {Box, Container, LinearProgress} from "@material-ui/core";
import {formatFeeDisplay, setCurrentFilters, applyCurrentFilter} from "../../../utilities/Common";

import OrganisationPackageExport from "./OrganisationPackageExport";
import ListActions from "../../../components/list/ListActions";
import CustomizableDatagrid from "../../../components/customized-datagrid";

const useStyles = makeStyles(theme => ({
    links: {
        color: '#2d9edf'
    },
    hiddenOnSmallScreens: {
        display: 'table-cell',
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    organisationFilter: {
        width: '20em'
    },
    cycleStatusFilter: {
        width: '50px'
    }
}));


const ListFilters = (props: Omit<FilterProps, 'children'>) => {
    const classes = useStyles();

    setCurrentFilters(props,
        ['organisationId', 'organisationUuid', 'isCustomPackage', 'isPsaCustomer', 'isPsaCustomer', 'countryUuid', 'skuUuid', 'state']);

    return (

        <Filter {...props} style={{float: 'left', paddingTop: '10px'}} >
            <TextInput label={'Id'} source={'organisationId'} alwaysOn resettable={true} style={{maxWidth: '100px'}} />
            {/*<TextInput label={'Organisation'} source={'organisationName'} alwaysOn resettable={true} />*/}
            <ReferenceInput source="organisationUuid" reference="organisations" label={'Organisation'}
                            filter={{country: localStorage.getItem('mId'), isProducer: 1, isActive: 1}}
                            sort={{name: 'asc'}} alwaysOn allowEmpty={false}
                            resettable className={classes.organisationFilter} >
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <SelectInput source="isCustomPackage" label={'Custom Package?'} choices={[
                { id: 'Yes', name: 'Yes' },
                { id: 'No', name: 'No' }
            ]} alwaysOn resettable={true} style={{minWidth: '170px'}} />
            <SelectInput source="isPsaCustomer" label={'PSA Customer?'} choices={[
                { id: 'Yes', name: 'Yes' },
                { id: 'No', name: 'No' }
            ]} alwaysOn resettable={true} />

            <ReferenceInput source="countryUuid" reference="countries" label={'Country'}
                            filter={{marketId: localStorage.getItem('mId')}} sort={{id: 'asc'}} resettable>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <ReferenceInput source="skuUuid" reference="skus" label={'SKU'} resettable >
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <TextInput label={'State'} source={'state'} resettable={true} />
        </Filter>
    )
}

const RecordRowClick = (id, basePath, record) => {
    // console.log(id, basePath, record);
    let url = `/billing/packages/organisations/${record.organisationUuid}`;
    if(record.skuUuid) {
        url = `/billing/packages/organisations/${record.organisationUuid}/${record.skuUuid}`;
    }
    return url;
};

const OrganisationPackageList: FC<ListProps> = props => {
    useAuthenticated();
    const loading = useLoading();
    const classes = useStyles();
    let defaultFilterValues = {marketId: localStorage.getItem('mId')};
    defaultFilterValues = applyCurrentFilter(defaultFilterValues,
        ['organisationId', 'organisationUuid', 'isCustomPackage', 'isPsaCustomer', 'isPsaCustomer', 'countryUuid', 'skuUuid', 'state']);

    return (
        <React.Fragment>
            <Container style={{width: 'auto', overflowX: 'scroll', maxWidth: '100vw', padding: '8px'}}>
                { loading &&
                <Box>
                    <LinearProgress />
                </Box>
                }
                <List
                    {...props}
                    bulkActionButtons={false}
                    actions={<ListActions />}
                    filters={<ListFilters />}
                    filter={{marketId: localStorage.getItem('mId')}}
                    filterDefaultValues={defaultFilterValues}
                    perPage={10}
                    sort={{ field: 'id', order: 'desc' }}
                    exporter={OrganisationPackageExport}
                    style={{overflowX:'auto', maxHeight:"750px" }}
                >
                    <CustomizableDatagrid style={{ maxWidth: '1356px' }} rowClick={RecordRowClick} >
                        <TextField label={'Id'} source={'organisationId'} />
                        <TextField label={'Organisation'} source={'organisationName'} style={{paddingRight: '65px'}} />
                        <TextField label={'Country'} source={'countryName'} />
                        <TextField label={'State'} source={'state'} />
                        <TextField label={'Custom Package?'} source={'isCustomPackage'} />
                        <TextField label={'PSA Customer?'} source={'isPsaCustomer'} />
                        <DateField label={'PSA Start Date'} source={'psaStartDate'} />
                        <DateField label={'PSA End Date'} source={'psaEndDate'} />
                        <NumberField label={'Contracted Volume'} source={'volumeStartingOffset'} />
                        <NumberField label={'Guaranteed Supply'} source={'guaranteedSupply'} />
                        <TextField label={'Current Discount (%)'} source={'currentDiscount'} />
                        <DateField label={'Pricing Applicable From'} source={'pricingApplicableFrom'} />
                        <DateField label={'Pricing Applicable To'} source={'pricingApplicableTo'} />
                        <TextField label={'SKU'} source={'skuName'} />

                        <FunctionField render={record => ( formatFeeDisplay(record.issueFee)) } label={'Issue Fee'} source={'record.issueFee'} />
                        <FunctionField render={record => ( formatFeeDisplay(record.fixedFee)) } label={'Fixed Fee'} source={'record.fixedFee'} />
                        <FunctionField render={record => ( formatFeeDisplay(record.cleaningFee)) } label={'Cleaning Fee'} source={'record.cleaningFee'}/>
                        <FunctionField render={record => ( formatFeeDisplay(record.selfDistributionFixedDiscount)) } label={'Self Dist Fixed Discount'} source={'record.selfDistributionFixedDiscount'} />

                        <TextField label={'Freight Per Keg?'} source={'perKegFreight'} />

                        <FunctionField render={record => ( formatFeeDisplay(record.freightCapitalMetroFee)) } label={'Freight Fee - Capital Metro'} source={'record.freightCapitalMetroFee'}/>
                        <FunctionField render={record => ( formatFeeDisplay(record.freightRegionalMetroFee)) } label={'Freight Fee - Regional Metro'} source={'record.freightRegionalMetroFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.freightRegionalFee)) } label={'Freight Fee - Regional'} source={'record.freightRegionalFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.freightSuperRegionalFee)) } label={'Freight Fee - Super Regional'} source={'record.freightSuperRegionalFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.freightPickUpFee)) } label={'Freight-Pickup'} source={'record.freightPickUpFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.expressFee)) } label={'Next Day Delivery Fee'} source={'record.expressFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.palletFee)) } label={'Pallet Fee'} source={'record.palletFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.nonMystarFee)) } label={'Non-Mystar Fee'} source={'record.nonMystarFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.taproomVenueFee)) } label={'Taproom to Venue'} source={'record.taproomVenueFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.taproomDistributorFee)) } label={'Taproom to Distributor'} source={'record.taproomDistributorFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.taproomProducerFee)) } label={'Taproom to Producer'} source={'record.taproomProducerFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.dailyRentalFee)) } label={'Daily Rental'} source={'record.dailyRentalFee'}  />
                        <TextField label={'Timed Fee'} source={'timedFee'} />
                        <FunctionField render={record => ( formatFeeDisplay(record.collectionRegionalFee)) } label={'Collection - Regional'} source={'record.collectionRegionalFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.collectionSuperRegionalFee)) } label={'Collection - Super Regional'} source={'record.collectionSuperRegionalFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.stopAtDistributorFee)) } label={'Stop at Distributor Fee'} source={'record.stopAtDistributorFee'}  />
                        <FunctionField render={record => ( formatFeeDisplay(record.interCountryFee)) } label={'Intermarket Fee'} source={'record.interCountryFee'}  />
                    </CustomizableDatagrid>
                </List>

            </Container>
        </React.Fragment>
    );
};

export default OrganisationPackageList;
